import { Grid } from "@material-ui/core";
import { Tooltip, Typography } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as DeleteIcon } from "../../../src/assets/DeleteIcon.svg";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { ThemeContext } from "../../theme/ThemeContext";
import { deleteNDADocuments } from "./NDASlice";

export default function NDADelete(props) {
  const { open, handleClose } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const [payload, setPayload] = React.useState({
    deleteId : props.deleteId,
  });

  const handleSubmit = (data) => {
     dispatch(deleteNDADocuments(payload.deleteId))
     .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000")) {
        Toast(t("NDA document(s) deleted successfully."), "success");
        } 
        handleClose(false);
      })
      .catch((er) => { });
  };
  const handleTextOverflow = (text) => {
    if (text && text.length > 10) {
      return text.substring(0, 25) + "...";
    } else {
      return text;
    }
  };

  return (
    <>
      <DialogBox
        Header={t("dataTableDelete")}
        acceptText={t("CONFIRM")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        onClose={() => handleClose(false)}
        cancel={handleClose}
        onSubmit={handleSubmit}
        open={open}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems={"center"}
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
          }}
        >
          <Grid>
            <DeleteIcon width="60px" height={"50px"} />
          </Grid>
          <Grid>
            <Grid
              style={{
                wordWrap: "break-word",
                opacity: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                fontSize: "17px",
                marginTop: "15px",
              }}
            >
              <Typography
                style={{
                  color: darkMode ? "#fff" : "#242424",
                  fontSize: "15px",
                  marginRight: "4px",
                }}
              >
                {t("Are you sure you want to delete this document")} {" "}
              </Typography>
              <Typography
                style={{
                  fontSize: "15px",
                   color: darkMode ? "#fff" : "",
                }}
              >
                ?
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
